const posthogConfig = {
  enabled: Boolean(process.env.NEXT_PUBLIC_POSTHOG_KEY),
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY as string,
  host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? 'https://app.posthog.com',
} as const;

export default posthogConfig;
